<template>
  <RevPagination
    :current-page="currentPage"
    :current-page-label="`${currentPage}`"
    :navigation-aria-label="i18n(translations.pagination)"
    :next-aria-label="i18n(translations.navigate, { page: currentPage + 1 })"
    :page-aria-label="(page) => i18n(translations.navigate, { page })"
    :page-count="pageCount"
    :page-u-r-l="(num) => `?page=${num}`"
    :previous-aria-label="
      i18n(translations.navigate, { page: currentPage - 1 })
    "
  />
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevPagination } from '@ds/components/Pagination'

import { usePageNumberFromQuery } from '~/scopes/product-list/composables/usePageNumberFromQuery'

import translations from './Pagination.translations'

const i18n = useI18n()

const { currentPage } = usePageNumberFromQuery()

defineProps<{ pageCount: number }>()
</script>
